
import { useQuery } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import { getBookingCategories } from "../../../../../api/services";
import { FormAutocomplete } from "../../../../../components/fields";
import { ReactQueryKey } from "../../../../../types";
import { IFormValuesBookingsFilter } from "../../../types";

const FormCategories = () => {
    
    const { t } = useTranslation('booking');

    const categoriesQuery = useQuery({
        queryKey: [ReactQueryKey.BookingCategories, {tenants:[],dealers:[]}],
        queryFn: () => getBookingCategories({tenants:[],dealers:[]}),
        enabled: false
    });

    const handleOnOpen = () => {
        if(categoriesQuery.data == undefined) 
            categoriesQuery.refetch();
    }

    return (
        <FormAutocomplete<IFormValuesBookingsFilter>
            name="categories"
            label={t('label.categories')}
            options={categoriesQuery.data || []}
            loading={categoriesQuery.isLoading}
            multiple
            isOptionEqualToValue={(option, value) => option.code === value.code}
            onOpen={handleOnOpen}
        />
    );
};

export default FormCategories;